module.exports = __webpack_public_path__ + "img/矩形-蓝色@2x.5fa4c178.png";